import { styled } from '@mui/material';

export const VideoContainer = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 60%;
`;
